<app-header></app-header>
<div class="responsive">
    <div class="container-fluid">



        <div class="row">
            <div class="col-md-3">
                <app-sidebar></app-sidebar>
            </div>
            <div class="col-md-6">

                <!-- <div *ngIf="!loading">

                    <div *ngFor="let props of arr">
                        <app-card-skelton title='Events'></app-card-skelton>
                    </div>
                </div> -->


                <div class="row">
                    <div class="col-md-12">
                        <div class="card margin-b">
                            <div class="card-body card-body-noshadow">
                                <div class="display margin-b">
                                    <div class="image-wrapper wrapper-style">
                                        <img class="wrapper-style" [src]="currentUser.photo"
                                            (error)="getErrorImage($event)">
                                    </div>
                                    <div class="text-area margin-b">
                                        <div style="margin-top: 20px;">
                                            <h5 class="card-title">{{currentUser.name| titlecase}}</h5>
                                        </div>
                                        <div class="time-text">

                                        </div>
                                    </div>
                                </div>
                                <p class="card-text">

                                    Let's chat with partner
                                </p>
                            </div>

                            <div class="card-body" style="text-align:right;">
                                <div style="display: inline-flex;">
                                    <div>
                                        <span><i class="far fa-thumbs-up margin-l"></i></span>


                                    </div>


                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12" style="min-height: 500px;">


                        <app-no-results-found *ngIf="commentArr.length == 0 && loading" title='Comments'>
                        </app-no-results-found>



                        <div *ngIf="!loading && commentArr.length == 0">
                            <div *ngFor="let props of arr1">
                                <app-card-skelton></app-card-skelton>
                            </div>
                        </div>




                        <div *ngIf="loading">
                            <div *ngFor="let props of arr">
                                <app-alert-card size=2 [showtext]=true [data]="props"></app-alert-card>
                            </div>
                            <div *ngIf="showButton" style="text-align:center">
                                <button type="button" class="btn color main-backgroundcolor btn-sm pull-right"
                                    (click)="showMore()">
                                    Show more</button>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="row">

                    <div class="col-md-12">
                        <div class="row message-box">
                            <div class="col-md-10">
                                <form>
                                    <div class="form-group">

                                        <input type="text" class="form-control" [(ngModel)]="comment"
                                            [ngModelOptions]="{standalone: true}"
                                            placeholder="Let's add some of yours comments...">

                                    </div>
                                </form>
                            </div>
                            <div class="col-md-2">

                                <button type="button" class="btn color main-backgroundcolor
                                    " (click)="createComment()">
                                    Send
                                </button>
                            </div>
                        </div>
                    </div>
                </div>


            </div>



            <div class="col-md-3">
                <app-events [showheader]=true></app-events>

            </div>
        </div>
    </div>
</div>